<template>
  <lazy-div :load="doInit">
    <v-card>
      <v-card-title primary-title>
        <h3 class="headline mb-0">Print Certificate</h3>
        <v-btn flat icon color="primary" title="Load Report History" @click="viewRptHistory">
          <v-icon>mdi-archive</v-icon>
          <rpt-jobs-history title="Report History" id="travelPrintCertificate" v-model="rptHistory" @close="doClose"></rpt-jobs-history>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <form>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-text-field :label="labels.customName" v-model="reportForm.customName" data-vv-name="customName" :data-vv-as="labels.customName"></v-text-field>
              </v-flex>
              <v-flex xs12 md6></v-flex>
              <v-flex xs12 md6>
                <v-text-field v-model="reportForm.proposalNo" :label="labels.proposalNo" :data-vv-as="labels.proposalNo" data-vv-name="proposalNo" :error-messages="errors.collect('proposalNo')" @change="getProposalInsured"></v-text-field>
              </v-flex>
              <v-flex xs12 md6></v-flex>
              <v-flex xs12 md6>
                <v-autocomplete :items="certTypeList" v-model="reportForm.certType" :label="labels.certType" item-text="label" item-value="value" data-vv-name="certType" :data-vv-as="labels.certType" :error-messages="errors.collect('certType')" @input="getProposalInsured"></v-autocomplete>
              </v-flex>
              <v-flex xs12 md6></v-flex>
              <v-flex lg6 xs12>
                <v-checkbox v-model="reportForm.sendEmail" :label="labels.sendEmail" data-vv-name="sendEmail" :data-vv-as="labels.sendEmail"></v-checkbox>
              </v-flex>
              <v-flex xs12>
                <v-data-table v-if="this.displayInsured" :headers="this.headers" :items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.name }}</td>
                    <td>{{ props.item.nricPassport }}</td>
                    <td>{{ props.item.dob }}</td>
                    <td align='center'>
                      <v-tooltip bottom>
                        <v-btn icon slot="activator" color="primary" flat type="submit" :loading="submitting" @click.prevent="doExportIndividual(props.item.seqNo)">
                          <v-icon dark>mdi-file-export</v-icon>
                        </v-btn>
                        <span>{{labels.export}}</span>
                      </v-tooltip>
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
              <v-flex xs12 class="pt-3">
                <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doExport" v-if="!this.displayInsured">
                  <v-icon left dark>mdi-file-export</v-icon>
                  {{labels.export}}
                </v-btn>
                <v-btn-toggle mandatory v-model="reportForm.format">
                  <v-btn flat v-for="format in supportedList" :key="format.value" :value="format.value">
                    <span>{{format.label}}</span>
                    <v-icon :color="format.color">{{format.icon}}</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </v-card-text>
    </v-card>
  </lazy-div>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import * as TableConst from '@/mixins/table'
import RptJobsHistory from '../../shared/RptJobsHistory'

export default {
  data() {
    return {
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'NRIC/Passport', value: 'nricPassport' },
        { text: 'Date of Birth', value: 'dob' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      selectedColumns: ['name', 'nricPassport', 'dob'],
      labels: {
        customName: 'Report Name',
        proposalNo: 'Proposal No.',
        certType: 'Type of Certificate',
        format: 'Export Format',
        export: 'Export to',
        sendEmail: 'Send Output to Email?'
      },
      reportForm: {
        customName: undefined,
        proposalNo: undefined,
        certType: undefined,
        format: undefined,
        sendEmail: false
      },
      menu: {},
      certTypeList: [],
      supportedFormat: [],
      submitting: false,
      displayInsured: false,
      selectedSeqNo: undefined,
      rptHistory: false
    }
  },
  computed: {
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    listHeaders() {
      let result = []
      for (const selectedColumn of this.selectedColumns) {
        let findCol = this.columns.find(a => selectedColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      return result
    }
  },
  watch: {
    'supportedList': function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.reportForm.format = value[0].value
      }
    }
  },
  methods: {
    async doInit() {
      try {
        const apiURI = this.$store.state.reports.agencyReports.menu.travelPrintCertificate
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.certTypeList = data.certTypeList
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)

            if (this.certTypeList) {
              this.reportForm.certType = this.certTypeList[0].value
            }
          }
        }
      } catch (err) {
        throw err
      }
    },
    async getProposalInsured() {
      try {
        if (this.reportForm.proposalNo && this.reportForm.certType === 'I') {
          this.displayInsured = true
          this.loading = true
          const apiURI = this.menu.proposalInsured
          if (apiURI) {
            try {
              const expand = {
                proposalNo: this.reportForm.proposalNo,
                certType: this.reportForm.certType
              }
              const result = await this.$http.get(expandURI(apiURI, expand))
              if (result.data) {
                const { data } = result.data
                if (data) {
                  this.items = []
                  data.map((proposalInsured) => {
                    const convertTravelInsured = {
                      name: proposalInsured.name,
                      nricPassport: proposalInsured.nricPassport,
                      dob: proposalInsured.dob,
                      seqNo: proposalInsured.seqNo
                    }
                    this.items.push(convertTravelInsured)
                  })
                }
                this.loading = false
              }
            } catch (error) {
              this.displayInsured = false
              this.loading = false
              throw error
            }
          } else {
            this.errorMessage('Invalid API URL')
            this.loading = false
          }
        } else {
          this.displayInsured = false
        }
      } catch (err) {
        throw err
      }
    },
    doExportIndividual(seqNo) {
      this.selectedSeqNo = seqNo
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    doExport() {
      this.selectedSeqNo = undefined
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          const exportForm = {
            customName: this.reportForm.customName,
            proposalNo: this.reportForm.proposalNo,
            certType: this.reportForm.certType,
            format: this.reportForm.format,
            selectedSeqNo: this.selectedSeqNo
          }
          await this.$http.post(apiURI, exportForm)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    viewRptHistory() {
      this.rptHistory = true
    },
    doClose(rptKeys) {
      if (rptKeys !== undefined && rptKeys !== null) {
        JSON.parse(rptKeys, (key, value) => {
          if (key === 'proposalNo') {
            this.reportForm.proposalNo = value
          } else if (key === 'certType') {
            this.reportForm.certType = value
          } else if (key === 'format') {
            this.reportForm.format = value
          } else if (key === 'sendEmail') {
            this.reportForm.sendEmail = value
          }
        })
      }
      this.getProposalInsured()
      this.rptHistory = false
    }
  },
  components: {
    RptJobsHistory
  },
  mixins: [
    MessageMixin,
    TableConst.default
  ]
}
</script>

<style lang="scss">

</style>
